import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'

const PanagyurskiPrepisView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ПАНАГЮРСКИ ПРЕПИС</h1>
                        <p className="lead">НА „ИСТОРИЯ СЛАВЯНОБЪЛГАРСКА“ (РИЛСКИ МАНАСТИР, 1825)</p>
                    </div>
                    <p>Ръкопис № НБКМ 1236, който принадлежи към родословното дърво на Компилативната редакция на Паисий Рилски от 1825 г., се описва от всички изследователи с условното работно заглавие: </p>
                    <ul>
                        <li>„Панагюрски препис“ <small>(Тодоров 1985: 197; Радев 2012-1: 225 – 228; Димитрова, Пеев 2012: 62)</small>.</li>
                    </ul>
                    <p>Мястото и времето на съставяне на Панагюрския препис са неизвестни; неизвестен е и преписвачът му. </p>
                    <p>Оригиналното ръкописно книжно тяло е издирено от  Стоян Петрински в дома на един от участниците в Априлското въстание от Панагюрище (Радев 2012: 5 – 26). Самият Панагюрски препис влиза в полето на научното изследване чак през 60-те г. на ХХ век, едва в описа на Христо Кодов и Маньо Стоянов (Кодов и Стоянов 1971: 79 – 80). По-късно Илия Тодоров открива родство между Кесариевия и Панагюрския преписи. Включва ги и в генеалогичната схема на Компилативната редакция на Рилската преправка, но не предлага задълбочено текстологично проучване (Тодоров 1985: 196 - 197). Цялостна текстологична съпоставка на Кесариевия и Панагюрския преписи се прави за пръв път в книгата на Иван Радев „Кесарий п. Василев и неговият препис „Летопис славяноболгарски“ (Радев 2012-1: 5 – 26). Наблюденията водят Ив. Радев до извода за безспорното родство между двата ръкописа. Науката не е установила последващо преписване на Панагюрския препис. </p>
                    <p>Днес оригиналът на Панагюрския препис се съхранява под № НБКМ 1236 в Националната библиотека „Св. св. Кирил и Методий“ в София (сигнатурата е по Кодов, Стоянов, 1971: 79 – 80). Ръкописът все още не е издаван. </p>
                    <p className="text-right">Паспортът на ръкописа е съставен от доц. д-р Мила Кръстева <br/>12.07.2018 г.</p>
                    
                </main>
            </div>
        </MainLayout>
    )
}

PanagyurskiPrepisView.propTypes = {
    
}

export default PanagyurskiPrepisView



// WEBPACK FOOTER //
// ./src/views/PanagyurskiPrepis/index.js